module.exports = __webpack_public_path__ + "static/media/objects2_01.2a2ffeb8.svg";